var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRoundedPlayMedium = function SvgRoundedPlayMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 22.577c.037 1.614 1.706 2.591 3.168 1.823l11.757-6.61c.64-.36 1.075-1.02 1.075-1.794s-.434-1.434-1.075-1.795l-11.757-6.6c-1.462-.768-3.13.2-3.168 1.814z"
  })));
};
export default SvgRoundedPlayMedium;